<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;

  let mailer_endpoint = 'https://gorgeous.works/mailer';
  let recaptcha = '6LfVGccbAAAAAKOVFTJw_tJrQBazrYDuHejx-BvN';

  function submitMessage(e) {
      const form = document.getElementById("send-email");
      e.preventDefault();
      grecaptcha.ready(function() {
          grecaptcha.execute(recaptcha, {action: 'submit'}).then(function(token) {
              const XHR = new XMLHttpRequest(),
                    FD  = new FormData(form);

              FD.append("token", token);

              // Define what happens on successful data submission
              XHR.addEventListener('load', function( event ) {
                  if (XHR.status === 200) {
                      form.classList.remove("was-validated");
                      form.reset();
                      alert( 'Your message has been sent, thank you for your inquiry.' );
                  }
                  else if (XHR.status === 400) {
                      alert(XHR.responseText);
                  }
                  else {
                      alert( 'Something went wrong, please try again.' );
                  }
              });

              // Define what happens in case of error
              XHR.addEventListener('error', function( event ) {
                  alert( 'Oops! Something went wrong.' );
              } );

              // Set up our request
              XHR.open( 'POST', mailer_endpoint );

              // Send our FormData object; HTTP headers are set automatically
              XHR.send( FD );
          });
      });
  }
</script>

<section style="{style(block)}">
<div class="page-header py-5" style="background-image: url({image(block, 'picture', [null, 800])}); background-size: cover;">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-7 d-flex justify-content-center flex-column">
        <div class="card card-body d-flex justify-content-center shadow-lg p-5">
          <h3 class="text-center text-primary">{text(block, 'title')}</h3>
          <p>{text(block, 'text')}</p>
          <form id="send-email" role="form" autocomplete="off" on:submit={submitMessage}>
            <div class="card-body p-0">
              <div class="row">
                <div class="col-md-6">
                  <label>{text(block, 'labelName')}</label>
                  <div class="input-group mb-4">
                    <input class="form-control" placeholder="" aria-label="First Name..." type="text" name="name" required>
                  </div>
                </div>
                <div class="col-md-6 ps-2">
                  <label>{text(block, 'labelEmail')}</label>
                  <div class="input-group">
                    <input type="tel" class="form-control" placeholder="" name="email" required>
                  </div>
                </div>
              </div>
              <div class="form-group mb-4">
                <label>{text(block, 'labelMessage')}</label>
                <textarea name="msg" class="form-control" id="message" rows="4" required></textarea>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-check form-switch mb-4">
                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" checked="" required>
                    <label class="form-check-label" for="flexSwitchCheckDefault">{@html richtext(block, 'terms')}</label>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row justify-content-center">
                    <div class="col-lg-3">
                      <a href="{url(block, 'buttonSecondary')}" class="btn bg-gradient-primary w-100">
                        {text(block, 'buttonSecondary')}
                      </a>
                    </div>
                    <div class="col-lg-3">
                      <button type="submit" class="btn bg-gradient-primary w-100">
                        {text(block, 'buttonName')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</section>
